// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

export const CostumerConsultantFragmentDoc = `
    fragment costumerConsultant on Consultant {
  id
  avatarImage {
    __typename
    url
  }
  firstName
  user {
    id
    email
  }
}
    `;